export default __webpack_public_path__ + "static/rejata-affd738eae23bb5b58e6ab6950cc2f6c.png";